const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const deleteDepositMethodApi = async (methodId) => {
    const token = localStorage.getItem('token');
    
    if (!token) {
        console.error('[deleteDepositMethodApi] Ошибка: Токен авторизации не найден.');
  
          // throw new Error('Токен авторизации не найден.');
      }

    const url = `${API_BASE_URL}/admin/lead/deposit-methods/${methodId}`;

    try {
        const response = await fetch(
            url, 
            {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось удалить метод депозита`);
        }
        return response.status === 204 ? response : await response.json();
        
    } catch (error) {
        throw error;
    }
};